<template>
  <menu-item-groups-abs type="dessert"/>
</template>

<script>
import MenuItemGroupsAbs from "./MenuItemGroupsAbs";
export default {
  name: "Desserts-Groups",
  components: {
    MenuItemGroupsAbs
  },
  data: () => ({
  }),
  methods: {
  }
};
</script>
